export const maintenanceStatusSelector = (state) => ({
  maintenanceStatus: state.systems.maintenanceStatus
});
